import React, { useState } from "react";
import { PayPalButtons } from "@paypal/react-paypal-js";
import { toast } from "sonner";
import { api } from "@/lib/api";
import { apiError } from "@/lib/apiError";
import { useI18n } from "@/lib/i18n";
import { logError } from "@/lib/log";

/** USD checkout for studios who cannot pay through Midtrans. One-time payment only.
 *  The SDK script is loaded once by the page, not once per plan. */
export const PayPalCheckout = ({ planId, promoCode, onPaid }) => {
  const { t } = useI18n();
  const [orderId, setOrderId] = useState(null);

  const createOrder = async () => {
    const res = await api.post("/billing/paypal/checkout", {
      plan_id: planId,
      promo_code: promoCode || null,
    });
    setOrderId(res.data.order_id);
    return res.data.paypal_order_id;
  };

  const onApprove = async () => {
    try {
      const res = await api.post(`/billing/paypal/capture/${orderId}`);
      if (res.data.status === "pending_review") {
        toast.info(t("paypal_pending_review"), { description: t("paypal_pending_review_hint"), duration: 12000 });
      } else {
        toast.success(t("payment_received"));
      }
      onPaid();
    } catch (err) {
      toast.error(apiError(err, t("paypal_not_confirmed")));
    }
  };

  return (
    <div className="mt-8" data-testid={`paypal-block-${planId}`}>
      <PayPalButtons
        style={{ layout: "vertical", color: "gold", shape: "rect", height: 44, label: "paypal" }}
        createOrder={createOrder}
        onApprove={onApprove}
        onCancel={() => toast.info(t("checkout_closed"))}
        onError={(err) => {
          logError("PayPal checkout failed", err);
          toast.error(t("payment_failed"));
        }}
      />
    </div>
  );
};
